<template>
  <div class="container">
    <div @click="goback" style="font-size:14px;margin-bottom:10px;cursor: pointer;width:50px">
      <i class="el-icon-back"></i>
      返回
    </div>
    <div style="display: flex">
      <el-form :model="form" :rules="rules" ref="form" label-width="200px" style="width:600px">
        <el-form-item label="反馈账号">
            <el-input v-model="form.email" disabled></el-input>
            <el-button type="info" size="mini" style="position: absolute;margin-top: 6px;margin-left: 2px;" @click="AccountInfo">账号详情</el-button>
        </el-form-item>
        <el-form-item label="反馈类型">
            <el-input v-model="form.type" disabled></el-input>
        </el-form-item>
        <el-form-item label="产品型号">
            <el-input v-model="form.product_id" disabled></el-input>
        </el-form-item>
        <el-form-item label="反馈时间">
            <el-input v-model="form.create_time" disabled></el-input>
        </el-form-item>
        <el-form-item v-if="question_answer!==''" label="已回复内容">
          <el-input :rows="5" type="textarea" disabled v-model="question_answer"></el-input>
        </el-form-item>
        <el-form-item label="状态">
            <el-select v-model="form.status" placeholder="">
                <el-option label="未处理" :value="1"></el-option>
                <el-option label="处理中" :value="2"></el-option>
                <el-option label="已处理" :value="3"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item prop="backcontent" label="回复内容">
          <el-input :rows="5" type="textarea" v-model="form.backcontent"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="Validate(submit)">提交</el-button>
        </el-form-item>
      </el-form>
      <div style="margin-left:200px;flex:1">
        <h4 style="margin: 17px 0">反馈内容</h4>
        <el-input :rows="10" disabled type="textarea" v-model="form.content"></el-input>
        <div class="image" v-show="mediaList.length">
          <template v-for="(img,key) in mediaList">
            <video v-if="isVideo(img)" :key="'v'+key" @click="checkVideo(img)" style="height:100px;cursor:pointer;margin:0 5px" :src="img"></video>
            <el-image v-else :key="'i'+key" style="height:100px;margin:0 5px" :src="img" :preview-src-list="imageList" fit="cover"></el-image>
          </template>
        </div>
        <div class="file-list" v-show="fileList.length">
          <div class="file-item" v-for="(file,key) in fileList" :key="'f'+key">
            <i class="el-icon-document"></i>
            <span class="file-name" :title="fileName(file)">{{ fileName(file) }}</span>
            <el-button type="text" size="mini" @click="downloadFile(file)">下载</el-button>
          </div>
        </div>
        <el-dialog title="视频预览" v-model="showVideoViewer" width="70%" top="5vh" append-to-body>
          <div style="height:75vh;display:flex;align-items:center;justify-content:center;background:#000">
            <video v-if="showVideoViewer" :src="videoUrl" controls autoplay style="width:100%;height:100%;object-fit:contain"></video>
          </div>
        </el-dialog>
      </div>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
import util, { getRegion } from '../../../util/util'
export default {
  name: '',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      form: {
        content: '',
        create_time: '',
        email: '',
        image: '',
        product_id: '',
        status: '',
        type: '',
        backcontent: '',
        uid: ''
      },
      rules: {
        backcontent: [{ required: true, message: '请输入回复内容', trigger: 'blur' }],
      },
      infocode: '',
      feedtypeIdName: {},
      modelIdName: {},
      content: '',
      formimges: [],
      question_answer: '',
      videoUrl: '',
      showVideoViewer: false
    }
  },
  computed: {
    // 图片 + 视频，横向缩略图展示
    mediaList () {
      return (this.formimges || []).filter(item => this.isImage(item) || this.isVideo(item))
    },
    // 除图片/视频之外的附件，每个文件独占一行
    fileList () {
      return (this.formimges || []).filter(item => !this.isImage(item) && !this.isVideo(item))
    },
    imageList () {
      return (this.formimges || []).filter(item => this.isImage(item))
    }
  },
  watch: {},
  methods: {
    AccountInfo() {
      this.$router.push('/iot/userinfo/'+ this.form.uid + '&' + getRegion('region_change') + '&' + 'feedback' + '&' + this.infocode)
    },
    isVideo (url) {
      return /\.(mp4|mov|avi|wmv|flv|mkv|webm|m4v|3gp)(\?|$)/i.test(url)
    },
    isImage (url) {
      return /\.(jpg|jpeg|png|gif|bmp|webp|svg|ico|heic|heif|tiff?)(\?|$)/i.test(url)
    },
    // 从 URL 中解析文件名（去掉查询参数并解码）
    fileName (url) {
      if (!url) return ''
      const path = String(url).split('?')[0].split('#')[0]
      const name = path.substring(path.lastIndexOf('/') + 1)
      try {
        return decodeURIComponent(name) || url
      } catch (e) {
        return name || url
      }
    },
    // 附件是 S3 预签名地址（跨域且区域随反馈所属区变化），只能直接跳转交给浏览器处理。
    // 想强制变成"另存为"，需要后端在签发预签名时带上 response-content-disposition=attachment，
    // 该参数必须参与签名，前端拼接会导致签名失效。
    downloadFile (url) {
      if (!url) return
      const link = document.createElement('a')
      link.setAttribute('href', url)
      link.setAttribute('download', this.fileName(url))
      link.setAttribute('rel', 'noopener')
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    checkVideo (item) {
      this.videoUrl = item
      this.showVideoViewer = true
    },
    GetfeedType(){
      this.api.FeedTypeList({
        page: 1,
        limit: 100,
      }).then(res => {
        if (res.data.code == 200) {
          this.GetModelList()
          res.data.data.data.forEach(item => {
            this.feedtypeIdName[item.id] = item.name
          })
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    GetModelList () {
      this.api.ProductModelList({
        page: 1,
        limit: 100,
      }).then(res => {
        if (res.data.code == 200) {
          res.data.data.data.forEach(item => {
            this.modelIdName[item.id]=item.name
          })
          this.GetInfo()
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    GetInfo () {
      this.api.FeedBackListDetail({
        code: this.infocode
      }).then(res => {
        if (res.data.code == 200) {
          this.form = res.data.data.feedback
          this.formimges = res.data.data.images
          this.form.type = this.feedtypeIdName[res.data.data.feedback.type]
          this.form.product_id = this.modelIdName[res.data.data.feedback.product_id]
          this.form.create_time = util.dateFormat(res.data.data.feedback.create_time)
          if (res.data.data.feedback.question_answer) {
            res.data.data.feedback.question_answer.forEach(item => {
              this.question_answer = this.question_answer+(this.question_answer!==''?'\n\n':'') + '|' + item.content
            })
          }
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    Validate: function (call) {
      this.$refs['form'].validate(res => {
        if (res && call) {
          call()
        }
      })
    },
    submit () {
        this.api.FeedBackListStatus({
            content: this.form.backcontent,
            id: this.form.id,
            status: this.form.status
        }).then(res => {
          if (res.data.code == 200) {
            this.$confirm('修改成功，是否返回反馈列表?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.goback()
            })
            return
          }
          this.$message.error('修改失败' + res.data.msg)
        })
    },
    goback () {
      this.$router.push('/iot/feedbacklist')
    }
  },
  filters: {},
  mounted () {
    this.infocode = this.$route.params.code
  },
  created () {
    this.GetfeedType()
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.image {height: 100px; text-align: right;}
.file-list
  margin-top 10px
.file-item
  display flex
  align-items center
  padding 6px 10px
  border 1px solid #ebeef5
  border-radius 4px
  margin-bottom 8px
  font-size 13px
  color #606266
  .file-name
    flex 1
    margin 0 8px
    overflow hidden
    text-overflow ellipsis
    white-space nowrap
</style>
